import { useAuth } from 'user-auth'
import { useGetCurrentWorkspace } from '~workspace/queries/useGetWorkspaceById'
import { Member_Role } from '~workspace/types/__generated/gql/graphql'

export const useIsWorkspaceMember = () => {
  const { user } = useAuth()
  const { data } = useGetCurrentWorkspace()

  if (!data || !user) return false

  const membership = data.memberCollection.items?.find(
    (membership) => membership?.user?.id === user.id
  )

  if (!membership) return false

  return [Member_Role.Owner, Member_Role.Member].includes(membership.role)
}
